const defaultTrashHoldMS = 10 * 60 * 1000 // 10 minutes

export const shouldScheduleRefresh = (header, thresholdInMilliseconds = defaultTrashHoldMS) => {
  if (!header?.startTime) return
  if (header.isGameLive) return true

  const currentTime = Date.now()
  const eventStartTime = new Date(header.startTime).getTime()

  return Math.abs(eventStartTime - currentTime) <= thresholdInMilliseconds || (Date.now() > new Date(header.startTime).getTime() && header.status !== 'closed')
}
